.PopoverContent {
  position: fixed;
  z-index: 50;
  width: max-content;
  box-shadow: var(--smooth-shadow);
  border-radius: var(--radius-xs);
  border: 1px solid var(--neutral-4);
  background-color: var(--white);
  padding: var(--space-sm);
  background-color: var(--white);
  color: var(--black);
  font-size: 0.9375rem;
  word-break: break-word;

  &[data-state="open"] {
    animation: fade-in 100ms ease-in-out forwards;
  }

  &[data-state="closed"] {
    animation: fade-out 100ms ease-in-out forwards;
  }

  &::backdrop {
    background: transparent;
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}
